import {BaseUserFlow, UserFlowList, UserFlowStep} from './BaseUserFlow';
import {UserFlowType} from './UserFlowFacade';

export class SaveUserFlow extends BaseUserFlow {
  protected type = UserFlowType.Save;

  /**
   * @inheritdoc
   */
  public canChangeStep(step: string): boolean {
    return false;
  }

  public getCurrentStep(): string {
    return this.steps[this.getStep()] || `${this.type}.${UserFlowStep.None}`;
  }

  /**
   * @inheritdoc
   */
  public configure(): UserFlowList {
    super.configure();
    const newSteps: UserFlowList = [];
    const {
      designerSettings: {authentication},
    } = this;

    if (authentication.canSignIn && !authentication.userRegistered) {
      newSteps.push(`${UserFlowType.Auth}.${UserFlowStep.Login}`);
    }

    if (
      this.designerSettings.behaviour.editProjectNameOnFirstSave &&
      0 === this.uiState.saveCount &&
      this.uiState.projectNaming.editName
    ) {
      newSteps.push(`${UserFlowType.Save}.${UserFlowStep.ProjectName}`);
    }

    newSteps.push(`${UserFlowType.Save}.${UserFlowStep.Save}`);

    return newSteps;
  }
}
